import React from "react";

export default function GUI_Credit(props) {
    return (
      <center><label style={{ fontSize: 12 , color: '#CCCCCC'}}>Code by Pujana P</label></center>
    );
  }
  